import { useMemo } from 'react'

import { api } from '@/shared/lib/api'

import type { FinishStepInput, LevelPlayAdapter } from './types'
import type { Step } from '../stepTypes'

/**
 * Adapter da jornada.
 *
 * Os steps já vêm prontos do bundle do nível, então a fonte é síncrona — o
 * caso degenerado do carregamento assíncrono, não um caminho paralelo.
 */
export const useJourneyAdapter = ({
  eventSlug,
  steps,
  allowWrongAnswers,
  livesLimit,
  journeyUid
}: {
  eventSlug: string
  steps: Step[]
  allowWrongAnswers: boolean
  livesLimit: number
  journeyUid?: string
}): LevelPlayAdapter =>
  useMemo(
    () => ({
      domain: 'journey' as const,

      stepSource: { kind: 'sync' as const, steps },

      allowWrongAnswers,
      livesLimit,

      async finishStep({ uid, payload }: FinishStepInput) {
        const record =
          payload.kind === 'voucher'
            ? { voucher_id: payload.voucherId }
            : { answer: payload.answer, right_answer: payload.answerIsRight }

        await api.post(
          `/user/digital_products/${eventSlug}/challenges/${uid}/finish`,
          { record }
        )
      },

      exitPath: () => `/jornadas/${journeyUid ?? ''}`
    }),
    [eventSlug, steps, allowWrongAnswers, livesLimit, journeyUid]
  )
